<template>
  <div id="app" class="fullscreen">
    <router-view />    
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { scene_data, early_audio, late_audio } from '@/data';

export default {
  name: 'App',
  components: {
  },
  created() {
    // get key
    const urlParams = new URLSearchParams(window.location.search);
    const key = urlParams.get('key');
    this.$store.commit('set_key', key);

    // prefetch resources
    var preloadLink;
    for (let i = 0; i < early_audio.length; i++) {
      let media = early_audio[i];
      preloadLink = document.createElement("link");
      preloadLink.href = media;
      preloadLink.rel = "prefetch";
      preloadLink.as = "audio";
      document.head.appendChild(preloadLink);
    }
    
    for (const scene of Object.values(scene_data)) {
      // console.log(scene);
      preloadLink = document.createElement("link");
      preloadLink.href = scene.cover;
      preloadLink.rel = "prefetch";
      preloadLink.as = "image";
      document.head.appendChild(preloadLink);

      preloadLink = document.createElement("link");
      preloadLink.href = scene.media[0];
      preloadLink.rel = "prefetch";
      preloadLink.as = "audio";
      document.head.appendChild(preloadLink);
    }
    
    for (let i = 0; i < late_audio.length; i++) {
      let media = late_audio[i];
      preloadLink = document.createElement("link");
      preloadLink.href = media;
      preloadLink.rel = "prefetch";
      preloadLink.as = "audio";
      document.head.appendChild(preloadLink);
    }

  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['scenes']),
  },
  methods: {
  },
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.fullscreen {
  /* position: fixed;
  left:0; top:0;
  z-index:1; */
  width:100%;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  /* height:100%; */
  background-color: white;
  /* overflow: scroll; */
}

.hidden {
  display: none;
}

p {
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}

/* buttons: https://webdesignerwall.com/tutorials/css3-gradient-buttons */
button {
  background-color: #EFEFEF;
	outline: none;
	cursor: pointer;
	text-shadow: 0 1px 1px rgba(0,0,0,.3);
	-webkit-border-radius: .5em; 
	-moz-border-radius: .5em;
	border-radius: .5em;
	-webkit-box-shadow: 0 1px 2px rgba(0,0,0,.2);
	-moz-box-shadow: 0 1px 2px rgba(0,0,0,.2);
	box-shadow: 0 1px 2px rgba(0,0,0,.2);
}
button:hover {
	text-decoration: none;
}
button:active {
	position: relative;
	top: 1px;
}
button:disabled {
	text-decoration: none;
  background-color: silver;
  color: grey;
}


/* common elementss */

.cover {
  width: 100%;
  /* max-width: 500px; */
}

/* common fixed control areas */
.middle-control {
  position: fixed;
  top: 12rem;
  left: 0;
  height: 30vh;
  width: 100%;
}

.bottom-control {
  position: fixed;
  bottom: 0;
  left: 0;
  /* height: 20vh; */
  width: 100%;
  text-align: center;
}
.bottom-control button {
  width: 9vh;
  height: 9vh;
  border-radius: 50%;
  border-color: grey;
  border-style: solid;
  background-color: #EFEFEF;
  color: #222;
  font-weight: bold;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}
.bottom-control button:active {
  background-color: #fff;
  color: #111;
  /* border-color: #bbb; */
}
.bottom-control button:disabled {
  background-color: #ddd;
  color: #bbb;
  border-color: #bbb;
}

/* global fade effects */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* specific elements */
ul.guidelines {
  padding-left: 2rem;
  padding-right: 2rem;
}
ul.guidelines li {
  list-style-type: none;
  padding: 0.3rem;
  border-bottom: thin solid silver;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

ul.guidelines {
  font-size: small;
}

.bottomspacer {
  padding-bottom: 25vh;
}

</style>
